<template>
    <div>
        <template v-if="payload.data === 'EVALUATE'">
            <userCommentElement
                :payload="payload"
                :message="message"></userCommentElement>
        </template>
        <template v-else-if="payload.data === 'inviteGroupChat'">
            <div class="tip">{{ message.nick }}邀请{{ payload.extension }}加入群聊</div>
        </template>
    </div>
</template>

<script>
import userCommentElement from './userCommentElement';
export default {
    name: "customElement",
    components: {
	    userCommentElement
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        }
    },
    created() {
    console.log('pppppppp', this.payload);
    }
}
</script>

<style lang="less" scoped>
.tip {
font-size: 10px;
font-family: PingFang SC;
font-weight: 400;
line-height: 20px;
color: #9DA0A4;
text-align: center;
}
</style>
